<template>
  <q-card
    class="person-card"
    :class="{ 'person-card--selected': selected }"
    @click="selectable ? $emit('toggle', person) : $emit('click', person)"
  >
    <div
    class="person-card__avatar-container"
    >
      <q-checkbox
        v-if="selectable"
        :model-value="selected"
        class="person-card__checkbox"
        @update:modelValue="$emit('toggle', person)"
        @click.stop
      />
      <q-avatar
        size="100px"
        color="grey-3"
        text-color="grey-6"
        class="person-card__avatar"
      >
        <q-img
          v-if="person.primaryFace && person.primaryFace.imageUrl"
          :src="person.primaryFace.imageUrl"
          :ratio="1"
          fit="cover"
        >
          <template v-slot:error>
            <q-icon name="fa fa-user-circle" size="40px" />
          </template>
        </q-img>
        <q-icon v-else name="fa fa-user-circle" size="40px" />
      </q-avatar>
    </div>

    <q-card-section class="q-pa-sm text-center">
      <div
        class="text-body2 ellipsis"
        :class="person.label ? 'text-weight-medium' : 'text-grey-5 text-italic'"
      >
        {{ person.label || 'Unnamed Person' }}
        <q-tooltip :delay="400">{{ person.label || 'Unnamed Person' }}</q-tooltip>
      </div>
      <div class="text-caption text-grey-6">
        Occurrences: {{ facesCount }}
      </div>
    </q-card-section>

    <q-card-actions
    v-if="!selectable && isGranted('MANAGE_PERSONS')"
    class="q-pa-xs q-pt-none justify-center">
      <q-btn
        size="sm"
        icon="fa fa-edit"
        color="grey"
        flat dense round
        @click.stop="$emit('edit', person)"
      >
        <q-tooltip>Edit</q-tooltip>
      </q-btn>
      <q-btn
        size="sm"
        icon="fa fa-trash"
        color="negative"
        flat dense round
        @click.stop="$emit('trash', person)"
      >
        <q-tooltip>Trash</q-tooltip>
      </q-btn>
    </q-card-actions>
  </q-card>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Person } from '@/analysis/types';
import isGranted from '@/auth/isGranted';

export default defineComponent({
  emits: ['click', 'edit', 'toggle', 'trash'],
  props: {
    person: {
      type: Object as () => Person,
      required: true,
    },
    selectable: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    facesCount(): number {
      return this.person.faceCount || 0;
    },
  },
  methods: { isGranted },
});
</script>

<style scoped>
.person-card {
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}

.person-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.person-card--selected {
  outline: 3px solid var(--q-primary);
}

.person-card__avatar-container {
  display: flex;
  justify-content: center;
  padding: 16px;
  position: relative;
}

.person-card__avatar {
  border: 2px solid #e0e0e0;
}

.person-card__checkbox {
  position: absolute;
  top: 8px;
  left: 8px;
}
</style>
